import { v4 as uuidv4 } from "uuid";
import { postData } from "../helper/helpers.functions";

export default class EmitNetworkRequest {
  constructor() {
    this.requests = [];
    this.refreshIntervalId = false;
  }

  addRequest(url, data, id) {
    if (!id) {
      this.requests.push({
        id: uuidv4(),
        url,
        data,
      });
    }

    if (!this.refreshIntervalId) {
      this.refreshIntervalId = setInterval(
        this.workRequestOff.bind(this),
        20000
      );
    }
  }

  workRequestOff() {
    clearInterval(this.refreshIntervalId);
    this.refreshIntervalId = false;
    this.requests.forEach((request) => {
      postData(request.url, request.data, false, request.id);
    });
  }
}
